// extracted by css-extract-rspack-plugin
export default {"container":"rX546P67PDYn4N4P__container___"};